/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanySearchCompanyCcnsQuery = gql`
  query GetSimulationCompanySearchCompanyCcnsQuery($siret: String) {
    getSimulationCompanySearchCompanyCcns_simulation_company(siret: $siret) {
      ccns {
 name  
idcc  
ref  
colleges  
}
    }
  }
`;

export default GetSimulationCompanySearchCompanyCcnsQuery;
